import { render } from "./add-edit-iwp-modal.html?vue&type=template&id=3ae58798&scoped=true&ts=true&external"
import script from "./add-edit-iwp-modal.ts?vue&type=script&lang=ts&external"
export * from "./add-edit-iwp-modal.ts?vue&type=script&lang=ts&external"

import "./add-edit-iwp-modal.scss?vue&type=style&index=0&id=3ae58798&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ae58798"]])

export default __exports__